<template>
  <b-modal
    v-model="trigger"
    :id="id"
    :ok-title="okTitle"
    :title="title"
    @ok="eventOk($event)"
    @cancel="eventCancel($event)"
    :centered="centered"
    :no-close-on-backdrop="dontCloseWhenClickedOutside"
    :no-close-on-esc="dontCloseWhenEscapePressed"
    :hide-header-close="dontShowCloseIcon"
    :ok-only="okOnly"
    :hide-footer="true"
    :hide-header="true"
    :size="'xl'"
  >
    <div class="empanel-modal-close">
      <span class="Modal-head-text">Partner Status</span>
      <p class>
        <img
          @click="closeEmpanelModal()"
          class="cursor-pointer modal-close-button mt-n1"
          style="float:right"
          src="@/assets/images/close1.svg"
        />
      </p>
    </div>
    <div class="p-4">
      <p class="mt-2 mb-2 Approver-Success-text">{{partnerStatusModalStartIndex}}</p>
      <p class="mt-2 mb-2 Approver-Success-text">{{partnerStatusModalEndIndex}}</p>
      <hr class="modal-horizontal-line mb-2" />
      <button
        class="btn primary-btn button-class mb-2"
        style="width: 70px; height: 30px; float:right;"
        v-on:click="closeEmpanelModal()"
      >Ok</button>
    </div>
  </b-modal>
</template>
<script>
export default {
  props: [
    "trigger",
    "text",
    "title",
    "centered",
    "dontCloseWhenClickedOutside",
    "dontCloseWhenEscapePressed",
    "dontShowCloseIcon",
    "partnerStatusModalStartIndex",
    "partnerStatusModalEndIndex"
  ],
  methods: {
    eventOk(event) {
      this.$emit("eventOk", event);
    },
    closeEmpanelModal(event) {
      this.$emit("eventClose", event);
    }
  }
};
</script>

<style>
.Modal-head-text {
  color: white;
  font-size: 13px;
  float: left;
}
.approve-tick-image {
  /* width: 23%; */
  height: 8vh !important;
  margin-left: auto !important;
  margin-right: auto !important;
}
.Approver-Success-text {
  text-align: center;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: #333333;
}
.modal-horizontal-line {
  margin-left: 0px;
  margin-right: 0px;
}
.modal-content {
  width: 100%;
  margin: auto;
}
.empanel-modal-close {
  padding: 8px !important;
  background-image: linear-gradient(to bottom, #1d76ae, #055396);
  border: 0.1px;
}
.Document-Number {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 12px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: #777777;
}
.button-class {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: center;
  color: white;
  border-radius: 2px;
  background-color: #1579ab;
}
.modal-body {
  padding: 0;
}
.modal-close-button {
  border: solid 1px #707070;
  color: rgba(0, 0, 0, 0.85);
  border-radius: 50%;
  background-color: rgb(255, 255, 255) !important;
  margin: 0.5px 0px 0px 5px !important;
  width: 18px;
}
</style>
